import { motion } from 'framer-motion';

const regions = [
  'Cham', 'Roding', 'Furth im Wald', 'Bad Kötzting', 'Schwandorf', 'Regensburg',
  'Weiden', 'Amberg', 'Straubing', 'Nürnberg', 'Passau', 'München',
];

const RegionSection = () => {
  return (
    <section id="einzugsgebiet" className="py-20 lg:py-28 bg-muted/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-6 text-center">
            CNC-Fertigung für die Oberpfalz und deutschlandweit
          </h2>
          <div className="space-y-4 text-muted-foreground text-base md:text-lg leading-relaxed">
            <p>
              Von Stamsried im Landkreis Cham aus fertigen wir Frästeile für Automatisierungstechnik
              und Sondermaschinenbau. Unsere Kunden kommen aus der gesamten Oberpfalz und aus
              Niederbayern – vom Konstruktionsbüro über den Maschinenbauer bis zum Instandhalter,
              der kurzfristig ein Ersatzteil braucht.
            </p>
            <p>
              Kurze Wege sind dabei ein echter Vorteil: Zeichnung am Vormittag, Rückmeldung innerhalb
              von Minuten über die FastLane, Fertigung häufig noch am selben Tag. Veredelungspartner
              wie Eloxieren, Verzinken oder Brünieren sitzen ebenfalls in der Region, Teile bringen
              und holen wir persönlich.
            </p>
            <p>
              Außerhalb der Region liefern wir deutschlandweit über Ihren Wunschversand – die
              Abstimmung läuft digital über STEP-Dateien und Zeichnungen.
            </p>
          </div>

          <p className="mt-8 text-sm text-muted-foreground text-center">
            Regelmäßig beliefert: {regions.join(' · ')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default RegionSection;